import FetchInterceptor from "configs/FetchInterceptor";

class DebtDownPaymentServices {
  static async getAll(requestBody) {
    const apiUrl = "/core/v1/purchase/payment/down-payment/get/all";
    const response = await FetchInterceptor.post(apiUrl, requestBody);
    return response;
  }

  static async add(requestBody) {
    const apiUrl = "/core/v1/purchase/payment/down-payment/add";
    const response = await FetchInterceptor.post(apiUrl, requestBody);
    return response;
  }

  static async getPdf(id) {
    const apiUrl = `/core/v1/purchase/payment/down-payment/get/pdf/${id}`;
    const response = await FetchInterceptor.get(apiUrl, {
      responseType: "blob",
    });
    return response;
  }

  static async getById(id) {
    const apiUrl = `/core/v1/purchase/payment/down-payment/get/${id}`;
    const response = await FetchInterceptor.post(apiUrl);
    return response;
  }
}

export default DebtDownPaymentServices;
